import { LoaderCircle } from 'lucide-react'


const Loader = () => {
    return (
        <div className='absolute top-1/2 left-1/2 flex items-center justify-center'>
            <LoaderCircle className="animate-spin" />
        </div>
    )
}

export default Loader